var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default"},[_c('div',{class:("default-background " + (!_vm.isDefaultLayout ? 'second' : ''))},[_c('Navbar'),_c('router-view'),_c('Footer'),_c('BottomNavbar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }